/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_1_QuestionInputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_7_questions_1_question = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_1_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is GridCraft faster than Excel?`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_7_questions_1_question = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_1_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 比 Excel 更快吗？`)
};

/**
* | output |
* | --- |
* | "Is GridCraft faster than Excel?" |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_1_QuestionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_7_questions_1_question = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_1_QuestionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_1_QuestionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_7_questions_1_question(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_7_questions_1_question(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_7_questions_1_question as "gc.search_guides.gridcraft_vs_excel.sections.7.questions.1.question" }